require( 'babel-polyfill' );
require( './util/polyfills' );
require( 'mdn-polyfills/Node.prototype.children' );
require( 'mdn-polyfills/Node.prototype.prepend' );
require( 'intersection-observer' );

import LazyLoad from './lazyload/lazyload';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

document.createElement( 'picture' );
require( 'picturefill' );

/*
### We had to add the Siema.js Libary localy, because it was necessary to change translate3d to translateY!
### translate3d and skew will cause a blur effect on the font/content
 */
import Siema from './vendor/siema.js';

let __svg__ = { path: './../assets/svg/*.svg', name: './../src/modules/partials/_icons/_icons.twig' };

const initializers = [
  {
    classObject: require( '../modules/global/backToTop/backToTop.module' ).default,
    selector: '.back-to-top'
  },
  {
    classObject: require( '../modules/global/header/header.module.js' ).default,
    selector: '.header'
  },
  {
    classObject: require( '../modules/global/cookie-layer/cookie-layer.module.js' ).default,
    selector: '.cookie-layer-outer'
  },
  {
    classObject: require( '../modules/global/search/search.module.js' ).default,
    selector: '.search'
  },
  {
    classObject: require( '../modules/global/jump-navigation/jump-navigation.module' ).default,
    selector: '.jump-navigation'
  },
  {
    classObject: require( '../modules/global/mainnavigation/mainnavigation.module' ).default,
    selector: '.mainnavigation'
  },
  {
    classObject: require( '../modules/global/metanavigation/metanavigation.module' ).default,
    selector: '.metanavigation'
  },
  {
    classObject: require( '../modules/global/footer/footer.module' ).default,
    selector: '.footer'
  },
  {
    classObject: require( '../modules/content/form/form.module' ).default,
    selector: '.form--wrapper'
  },
  {
    classObject: require( '../modules/global/nav-fourth-lvl/nav-fourth-lvl.module' ).default,
    selector: '.nav-fourth-lvl'
  },
  {
    classObject: require( '../modules/global/opt-in/opt-in.module' ).default,
    selector: '.opt-in'
  },
  {
    classObject: require( '../modules/content/accordion/accordion.module' ).default,
    selector: '.accordion'
  },
  {
    classObject: require( '../modules/content/counter/counter.module' ).default,
    selector: '.counter'
  },
  {
    classObject: require( '../modules/content/stage/stage.module' ).default,
    selector: '.stage'
  },
  {
    classObject: require( '../modules/content/downloadlist/downloadlist.module' ).default,
    selector: '.downloadlist'
  },
  {
    classObject: require( '../modules/content/linklist/linklist.module' ).default,
    selector: '.linklist'
  },
  {
    classObject: require( '../modules/content/image-slider/image-slider.module' ).default,
    selector: '.image-slider'
  },
  {
    classObject: require( '../modules/content/map/map.module' ).default,
    selector: '.map'
  },
  {
    classObject: require( '../modules/global/sitemap/sitemap.module' ).default,
    selector: '.sitemap'
  },
  {
    classObject: require( '../modules/content/slide-container/slide-container.module' ).default,
    selector: '.slide-container'
  },
  {
    classObject: require( '../modules/content/teaser-big/teaser-big.module' ).default,
    selector: '.teaser-big'
  },
  {
    classObject: require( '../modules/content/teaser-small/teaser-small.module' ).default,
    selector: '.teaser-small'
  },
  {
    classObject: require( '../modules/content/icons/icons.module' ).default,
    selector: '.icons'
  },
  {
    classObject: require( '../modules/content/table/table.module' ).default,
    selector: '.table'
  },
  {
    classObject: require( '../modules/content/cards/cards.module' ).default,
    selector: '.cards'
  },
  {
    classObject: require( '../modules/content/infographic/infoGraphicChartCreator.module' ).default,
    selector: '.charts-highchart'
  },
  {
    classObject: require( '../modules/content/slider-gallery/slider-gallery.module' ).default,
    selector: '.slider-gallery-list-wrapper'
  },
  {
    classObject: require( '../modules/content/image-map/image-map.module' ).default,
    selector: '.image-links'
  },
];

// go through all initializers
initializers.forEach(( initializer ) => {
  const tmp = document.querySelectorAll( initializer.selector );
  if ( tmp ) {
    [ ...tmp ].forEach(( node ) => {
      new initializer.classObject( node );
    });
  }
});

new LazyLoad();

// Scroll to a webform confirmation if exists.
document.addEventListener("DOMContentLoaded", function() {
  var confirmationElement = document.querySelector('.webform-confirmation .thank-you-page__headline');
  if (confirmationElement) {
    var yOffset = -250; // Adjust this value to add space on top
    var y = confirmationElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
});


